import { FormattedMessage } from 'react-intl';

const MultiValue = ({ index, getValue }) => {
  const count = getValue()?.length;

  if (index) {
    return null;
  }

  return <FormattedMessage id="FieldSelectCustom.multiValue" values={{ count }} />;
};

export default MultiValue;
